import { UserIcon } from "@/assets/icons";
import { strings } from "@/constants";
import type { UserInterface } from "@/interfaces";

export const ProfileHeader = ({
    isAdmin,
    roleLabel,
    user,
}: {
    isAdmin: boolean,
    roleLabel: string,
    user: UserInterface | null,
}) => (
    <div
        className="
            relative
            flex
            flex-row
            items-center
            gap-4
            border-b
            border-gray-200
            px-4
            py-4
            sm:px-6
            sm:py-6
            md:h-full
            md:flex-col
            md:items-center
            md:justify-center
            md:gap-4
            md:border-r
            md:border-b-0
            md:px-6
            md:py-8
            md:text-center
        "
    >
        <div
            style={{ background: "linear-gradient(135deg, #1356BC 0%, #0025BA 100%)" }}
            className="
                flex
                h-16
                w-16
                shrink-0
                items-center
                justify-center
                rounded-full
                text-white
                shadow-md
                md:h-24
                md:w-24
            "
        >
            <UserIcon className="h-8 w-8 md:h-12 md:w-12" />
        </div>
        <div className="min-w-0 flex-1 md:w-full md:flex-none">
            <h1
                className="
                    truncate
                    text-xl
                    font-bold
                    text-text-primary
                    sm:text-2xl
                "
            >
                {user?.name || strings.profile.notAvailable}
            </h1>
            <p
                className="
                    truncate
                    text-sm
                    text-text-secondary
                    md:mt-1
                "
            >
                {user?.email || strings.profile.notAvailable}
            </p>
            <span
                className={`
                    mt-3
                    hidden
                    rounded-full
                    px-3
                    py-1
                    text-xs
                    font-semibold
                    tracking-wide
                    uppercase
                    md:inline-block
                    ${isAdmin ? "bg-primary text-white" : "bg-primary/10 text-primary"}
                `}
            >
                {roleLabel}
            </span>
        </div>
        <span
            className={`
                shrink-0
                rounded-full
                px-3
                py-1
                text-xs
                font-semibold
                tracking-wide
                uppercase
                md:hidden
                ${isAdmin ? "bg-primary text-white" : "bg-primary/10 text-primary"}
            `}
        >
            {roleLabel}
        </span>
    </div>
);
